import { __assign } from "tslib";
import React, { useState } from 'react';
import FormLinks from '../FormLinks';
import { ErrorBoundary, Input, Button } from '../UI';
import validate from '../../utilities/validation';
import '../../index.css';
/**
 * Renders the sign-in component
 *
 * @param  {string} [className] - the CSS classes
 * @param  {(email: string) => void} [onClick] - onClick handler launching after submit form
 * @param  {string} [apiError] - api error messages
 * @param  {(to: string) => void} [onLinkHandler] - links onClick handler
 * @param  {string} [inputStyles] - input CSS classes for input
 * @param  {string} [buttonStyles] - btn CSS classes for button
 * @param  {string} [labelStyles] - the CSS classes for label
 * @param  {string} [linkStyles] - the CSS classes for link
 * @param  {string} [formStyles] - form CSS classes
 * @param  {string} [formGroupStyles] - form group CSS classes
 *
 * @example
 * <ForgotPassword
 *  className='a6y-react-auth__forgot-password'
 *  onClick={onClick}
 * />
 */
var ForgotPassword = function (_a) {
    var _b;
    var _c, _d, _e, _f;
    var _g = _a.className, className = _g === void 0 ? 'a6y-react-auth' : _g, onClick = _a.onClick, apiError = _a.apiError, onLinkHandler = _a.onLinkHandler, _h = _a.inputStyles, inputStyles = _h === void 0 ? '' : _h, _j = _a.buttonStyles, buttonStyles = _j === void 0 ? '' : _j, _k = _a.labelStyles, labelStyles = _k === void 0 ? '' : _k, _l = _a.linkStyles, linkStyles = _l === void 0 ? '' : _l, _m = _a.formStyles, formStyles = _m === void 0 ? '' : _m, _o = _a.formGroupStyles, formGroupStyles = _o === void 0 ? '' : _o;
    var _p = useState({
        email: '',
    }), forgotPasswordData = _p[0], setForgotPasswordData = _p[1];
    var _q = useState({
        email: false,
    }), errorData = _q[0], setErrorData = _q[1];
    var classNames = require('classnames');
    var FormClass = classNames((_b = {},
        _b[className + '__form' + "--error"] = errorData.email ? true : false,
        _b));
    var onInputChange = function (e, target) {
        var _a, _b;
        setErrorData(__assign(__assign({}, errorData), (_a = {}, _a[target] = e.target.value.length === 0, _a)));
        setForgotPasswordData(__assign(__assign({}, forgotPasswordData), (_b = {}, _b[target] = e.target.value, _b)));
    };
    var onSubmit = function (e) {
        e.stopPropagation();
        e.preventDefault();
        var data = [
            {
                value: forgotPasswordData.email,
                rules: ['CANNOT_BE_BLANK'],
            },
        ];
        if (onClick && validate(data)) {
            onClick(forgotPasswordData.email);
        }
        else {
            if (!errorData.email)
                setErrorData({ email: true });
        }
    };
    return (React.createElement("div", { className: className + '__forgot-password' },
        React.createElement("h1", null, globalThis.A6YReactAuthConfig &&
            ((_d = (_c = globalThis.A6YReactAuthConfig.components) === null || _c === void 0 ? void 0 : _c.forgotPassword) === null || _d === void 0 ? void 0 : _d.title)
            ? (_f = (_e = globalThis.A6YReactAuthConfig.components) === null || _e === void 0 ? void 0 : _e.forgotPassword) === null || _f === void 0 ? void 0 : _f.title
            : 'Forgot Password'),
        React.createElement(ErrorBoundary, { showError: apiError ? true : false }, apiError),
        React.createElement("form", { className: formStyles && formStyles.length > 0
                ? formStyles
                : className + "__form", onSubmit: function (e) { return onSubmit(e); } },
            React.createElement("div", { className: formGroupStyles && formGroupStyles.length > 0
                    ? formGroupStyles + " "
                    : className + "-group " + FormClass },
                React.createElement(Input, { id: 'email', placeholder: 'Email', typeInput: 'email', label: '', onChange: function (e) { return onInputChange(e, 'email'); }, value: forgotPasswordData.email, inputStyles: inputStyles, labelStyles: labelStyles })),
            React.createElement(Button, { className: buttonStyles, role: 'submit', style: 'primary' }, "Reset password")),
        React.createElement(FormLinks, { linkStyles: linkStyles, onLinkHandler: onLinkHandler })));
};
export default ForgotPassword;
//# sourceMappingURL=ForgotPassword.js.map